import { cn } from '~/lib/utils'

export const AppContainer = ({
  children,
  className,
}: React.PropsWithChildren & { className?: string }) => (
  <div
    className={cn(
      'p-4 rounded-2xl border bg-sidebar border-sidebar-border flex flex-col gap-4 flex-1',
      className,
    )}
  >
    {children}
  </div>
)
